import { NewContacts, AddContacts, Name, Age, Mobile, Save, Cancel } from '../../../../Constant';
import defaultuser from '../../../../assets/images/user/user.png';
import { Btn, Image, H6 } from '../../../../AbstractElements';
import ContactAppContext from '../../../../_helper/Contact';
import React, { Fragment, useContext, useState } from 'react';
import { Users } from 'react-feather';
import { Row, Col, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, Form } from 'reactstrap';
import { useForm } from 'react-hook-form';

const CreateContact = () => {
  const [modal, setModal] = useState(false);
  const [addurl, setAddurl] = useState(defaultuser);
  const toggle = () => setModal(!modal);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm(); // initialise the hook
  const { createUser } = useContext(ContactAppContext);

  const AddContact = (data) => {
    if (data !== '') {
      createUser(data, addurl);
      setModal(false);
    } else {
      errors.showMessages();
    }
  };

  const HandleAddUrl = (event) => {
    if (event.target.files.length === 0) return;
    //Image upload validation
    var mimeType = event.target.files[0].type;

    if (mimeType.match(/image\/*/) == null) {
      return;
    }
    // Image upload
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      setAddurl(reader.result);
    };
  };

  return (
    <Fragment>
      <Btn attrBtn={{ className: `badge-light-primary align-items-center btn-mail d-flex justify-content-start w-100 emptyContact`, color: 'primery', onClick: toggle }}>
        <Users className='me-2' />
        {"Add Admin"}
      </Btn>
      <Modal className='modal-bookmark' isOpen={modal} toggle={toggle} size='lg'>
        <ModalHeader toggle={toggle}>{"Add Admin"}</ModalHeader>
        <ModalBody>
          <Form className='form-bookmark needs-validation' onSubmit={handleSubmit("Add Admin")}>
            <div className='form-row'>
              <div className='contact-profile'>
                <Image attrImage={{ className: 'rounded-circle img-100', src: `${addurl}`, alt: '' }} />
                
              </div>
              <FormGroup className='col-md-12'>
                <Label><H6>{"Omang Number: "}</H6></Label>
                <Row>
                  <Col sm='6'>
                    <input className='form-control' name='omang' type='text' {...register('omang', { required: true })} />
                    <span style={{ color: 'red' }}>{errors.omang && 'Omang is required'}</span>
                  </Col>
                  
                </Row>
              </FormGroup>
              <FormGroup className='col-md-12'>
                <Label><H6>{"Admin Type: "}</H6></Label>
               
	  <select className='form-control' name="admin_type" {...register('admin_type', { required: true })}>
        <option value="ministry">Ministry</option>
        <option value="departmental">Departmental</option>
        <option value="at_large">Admin at Large</option>
      </select>
	  
                <span style={{ color: 'red' }}>{errors.admin_type && 'Please select type for this admin.'}</span>
              
			  </FormGroup>
              
			  <FormGroup className='col-md-12'>
                <Label><H6>{"Ministry: "}</H6></Label>
               
	  <select className='form-control' name="admin_ministry" {...register('admin_ministry', { required: true })}>
        <option value="ministry">Ministry of Agriculture</option>
        <option value="departmental">Ministry of State President</option>
        <option value="at_large">Ministry of Health</option>
      </select>
	  
                <span style={{ color: 'red' }}>{errors.admin_ministry && 'Please select Ministry for this admin.'}</span>
              
			  </FormGroup>
			  
			  <FormGroup className='col-md-12'>
                <Label><H6>{"Department: "}</H6></Label>
               
	  <select className='form-control' name="admin_department" {...register('admin_department', { required: true })}>
        <option value="ministry">Department of Veterinary Services</option>
        <option value="departmental">Department of Forestry</option>
        
      </select>
	  
                <span style={{ color: 'red' }}>{errors.admin_department && 'Please select department for this admin.'}</span>
              
			  </FormGroup>
			  
            
			</div>
            <Btn attrBtn={{ color: 'secondary', className: 'me-2' }}>{Save}</Btn>
            <Btn attrBtn={{ color: 'primary', onClick: toggle }}>{Cancel}</Btn>
          </Form>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default CreateContact;
